export default __webpack_public_path__ + "static/media/010.2bb02a0d.jpg";